// extracted by mini-css-extract-plugin
export default {"box":"add_box__baD7e","inputChange":"add_inputChange__Flxl4","body":"add_body__udhVl","time_input":"add_time_input__V6BRX"};